// extracted by mini-css-extract-plugin
export default {"bidLine":"BidCard_bidLine__s35cM","container":"BidCard_container__uvHcX","image":"BidCard_image__GlzuQ","left":"BidCard_left__DxLaj","right":"BidCard_right__g6Kek"};